import React, { useEffect, useContext } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Login from './components/Login';
import AuthRoutes from './services/AuthRoutes';
import GlobalContext from './contexts/GlobelContext'; // Correct import
import Dashboard from './components/Dashboard';
import Notfound from './components/Notfound/Notfound';
import PanNormal from './components/pages/pan-normal';
import PanAdvance from './components/pages/pan-advance';
import RcNormal from './components/pages/rc-normal';
import RcAdvance from './components/pages/rc-advance';
import AioAadharVerify from './components/pages/aio-aadhar-verify';
import AioAadharOtp from './components/pages/aio-aadhar-otp';
import AioOfflineAadharVerify from './components/pages/offline-aadhar-verify';
import BankVerification from './components/pages/bank-verification';
import ChangePassword from './components/pages/change-password';
import ForgotPassword from './components/pages/forgot-password';
import ResetPassword from './components/pages/reset-password';
import GstNormal from './components/pages/gst-normal';
import DrivingLicence from './components/pages/driving-licence';
import VoteridAdvance from './components/pages/voterid-advance';
import OfflinePan from './components/pages/offline-pan-verify';
import ChallanAdvance from './components/pages/challan-advance';
import RcReverse from './components/pages/rc-reverse';
import RcHistory from './components/pages/rc-history';
import RcOcr from './components/pages/rc-ocr';
import MarutiServiceHistory from './components/pages/rc-maruti-service-history';
import HyundaiServiceHistory from './components/pages/rc-hyundai-service-history';
import RctoMObile from './components/pages/rc-to-mobile';
import CreditScoreDetails from './components/pages/credit-score-details';
import MahindraServiceHistory from './components/pages/rc-mahindra-service-history';
import RcAdvancePlus from './components/pages/rc-advance-plus';
import UpiNormal from './components/pages/upi-verification';
import EchallanAdvancePlus from './components/pages/challan-advance-plus';
import ImportBulk from './components/pages/Bulk/manage-import-bulk';
import ExportBulk from './components/pages/Bulk/manage-export-bulk';
import RcBalckList from './components/pages/rc-black-list';
import RCInsuracneDetails from './components/pages/rc-insurance-details';
import RCToChassis from './components/pages/rc-to-chassis';
import Logs from './components/pages/logs'
import TollPlazaDetails from './components/pages/toll-plaza-charges';
import FastTag from './components/pages/fast-tag';

function App() {
  const { isUserAuth, setIsUserAuth } = useContext(GlobalContext);

  useEffect(() => {
    if (localStorage.getItem('loggedInUser') === 'true') {
      setIsUserAuth(true);
    } else {
      setIsUserAuth(false);
    }
  }, [setIsUserAuth]);

  console.log(isUserAuth);
  return (
    <Router>
      <Routes>
        <Route path="/" element={<AuthRoutes />}>
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/pan-normal" element={<PanNormal/>} />
          <Route path="/pan-advance" element={<PanAdvance/>} />
          <Route path="/rc-normal" element={<RcNormal/>} />
          <Route path="/rc-advance" element={<RcAdvance/>} />
          <Route path="/aio-aadhar-otp" element={<AioAadharOtp/>} />
          <Route path="/aio-aadhar-verify" element={<AioAadharVerify/>} />
          <Route path="/offline-aadhaar" element={<AioOfflineAadharVerify/>} />
          <Route path="/bank-verification" element={<BankVerification/>} />
          <Route path="/gst-normal" element={<GstNormal/>} />
          <Route path="/voterid-advance" element={<VoteridAdvance/>} />
          <Route path="/toll-plaza-charges-details" element={<TollPlazaDetails/>} />
          <Route path="/fast-tag" element={<FastTag/>} />
          <Route path="/offline-pan" element={<OfflinePan/>} />
          <Route path="/driving-licence" element={<DrivingLicence/>} />
          <Route path="/change-password" element={<ChangePassword/>} />
          <Route path="/challan-advance" element={<ChallanAdvance/>} />
          <Route path="/rc-reverse" element={<RcReverse/>} />
          <Route path="/rc-history" element={<RcHistory/>} />
          <Route path="/rc-ocr" element={<RcOcr/>} />
          <Route path="/maruti-service-history" element={<MarutiServiceHistory/>} />
          <Route path="/hyundai-service-history" element={<HyundaiServiceHistory/>} />
          <Route path="/mahindra-service-history" element={<MahindraServiceHistory/>} />
          <Route path="/rc-to-mobile" element={<RctoMObile/>} />
          <Route path="/credit-score-details" element={<CreditScoreDetails/>} />
          <Route path="/rc-advance-plus" element={<RcAdvancePlus/>}/>
          <Route path="/challan-advance-plus" element={<EchallanAdvancePlus/>}/>
          <Route path="/upi-normal" element={<UpiNormal/>}/>
          <Route path="/manage-import-bulk" element={<ImportBulk/>} />
          <Route path="/manage-export-bulk" element={<ExportBulk/>} />
          <Route path="/rc-black-list" element={<RcBalckList/>} />
          <Route path="/rc-insuracne-details" element={<RCInsuracneDetails/>} />
          <Route path="/rc-to-chassis" element={<RCToChassis/>} />
          <Route path="/manage-logs" element={<Logs/>} />
          <Route path="*" element={<Notfound />} />
        </Route>
        <Route path="/" element={<Navigate to="/login" />} />
        <Route path="/login" element={<Login />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />
      </Routes>
    </Router>
  );
} 

export default App;
